import React from "react";
// import ZenGanttChart from "./Common/Graph/ZenGanttChart";
import ZenDonut from "./Common/Graph/ZenDonut";

import liracrypt from "../Liracrypt/liracrypt";
import SessionError from "../ApiErrorComp/SessionError";
import ApiErrorComp from "../ApiErrorComp/ApiErrorComp";

class ZenSingleChart extends React.Component {
  state = {
    ZenDonut:null,
    loading: true,
    loginError: false,
    lid: "all",
    selectedMnt: "all",
    dataLoading: false,
  };

  constructor(props) {
    super(props);
    this._isMounted = false;
  }

  componentDidMount() {
    this.props.setPageHeader("Dashboard");
    this._isMounted = true;
    this.fetchTrendData()
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.loginError = false;
  }

  fetchTrendData = (selectedTab, lid = "all", mnt = "all") => {
    liracrypt
      // .get("/textapi", {
      //   lid,
      //   mnt,
      //   typ: "MainGraph",
      //   subTyp: selectedTab,
      //   dn: "SbLineDashbaord",
      // })
      .get("/chart/charttemplate", { "chartGroup" : "ZenSampleChart", "dictName" : "ZenSampleChart"} || {})
      .then(({ data }) => {
        const resp = { ...data };
        let respData = {};
        respData["ZenSampleChart"] = resp["data"]["ZenSampleChart"];
        respData["mainData"] = { ...resp };
        this._isMounted &&
          this.setState(
            {
              ...this.state,
              ...respData,
              loading: false,
              dataLoading: false,
            },
            () => {
              // console.log(this.state.dailyTrend);
            }
          );
      })
      .catch((error) => {
        // message.error('ERROR: Unable to save!', 4);
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            ApiErrorComp(error.response.status);
          } else {
            this.setState({
              ...this.state,
              loginError: true,
            });
          }
        }
      });
  };

  render() {
    if (this.state.mainData) {
      return (
        <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 0px 0px 10px",

                              width: "100%",
                            }}
                          >
                            <ZenDonut
                              divId={"ZenSampleChart"}
                              data={this.state.ZenSampleChart.data}
                              config={this.state.ZenSampleChart.config}
                              onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>
      );
    } else {
      return (
        <>
          {" "}
          <SessionError visible={this.state.loginError} />
          <div className="contentEmpty"></div>
        </>
      );
    }
  }
}
export default ZenSingleChart;